export default "__VITE_ASSET__DtQuH4Jc__"